import React from "react";
import { connect } from "react-redux";

import { Grid, Paper } from "@material-ui/core";

import useStyles from "../../styles";

import { Typography } from "../../../../components/Wrappers/Wrapper";
//store
import * as actions from "../../../../store/actions/actionIndex";


function AgentProgressSideBar(props) {
	var classes = useStyles();
	
	let Login = "00:00";
	props.statusData.map((data) => {
		if (data.name === "Login Time" && data.value) {
			let time = data.value.split(":");
			Login = time[0] + ":" + time[1];
		}
		return true;
	});

	return (
		<div>
			<Grid item md={false} sm={false} xs={12}>
				<Paper className={classes.ToggleBar}>
					<div className={classes.RemainingWork}>Today work hours</div>
					<Typography className={classes.TimeValue}>{Login}/24:00hrs</Typography>
					<div className={classes.progressSection}>
						
					</div>
				</Paper>
			</Grid>
		</div>
	);
}

const mapStateToProps = (state) => {
	return {
		agentState: state.agentData.agentState,
		breakReasons: state.breakReason.breakReasons,
		agentId: state.agentData.agentId,
		statusData: state.callData.posts,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		//onBreakReason: (agentId) => dispatch(actions.breakReason(agentId)),
		onAgentBreak: (agentId, breakState, breakType) => dispatch(actions.agentBreak(agentId, breakState, breakType)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(AgentProgressSideBar);
